'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CalendarTableHeaderCell = require('./calendar-table/CalendarTableHeaderCell');

var _CalendarTableHeaderCell2 = _interopRequireDefault(_CalendarTableHeaderCell);

var _CalendarTableRow = require('./calendar-table/CalendarTableRow');

var _CalendarTableRow2 = _interopRequireDefault(_CalendarTableRow);

var _OpeningCollection = require('../models/OpeningCollection');

var _OpeningCollection2 = _interopRequireDefault(_OpeningCollection);

var _dateUtils = require('../utils/dateUtils');

var _reactUtils = require('../utils/reactUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarTable = function (_React$Component) {
  _inherits(CalendarTable, _React$Component);

  function CalendarTable() {
    _classCallCheck(this, CalendarTable);

    return _possibleConstructorReturn(this, (CalendarTable.__proto__ || Object.getPrototypeOf(CalendarTable)).apply(this, arguments));
  }

  _createClass(CalendarTable, [{
    key: '_getStartOfWeek',
    value: function _getStartOfWeek(dates) {
      return (0, _dateUtils.containsWeekendDate)(dates) ? 0 : 1;
    }
  }, {
    key: '_renderColgroups',
    value: function _renderColgroups() {
      var _props = this.props,
          dates = _props.dates,
          navWidth = _props.navWidth;

      var width = (100 - navWidth * 2) / dates.length;
      var widthPercentage = width.toPrecision(5) + '%';
      return dates.map(function (date) {
        return _react2.default.createElement('colgroup', { key: date, className: 'calendar-table__day-colgroup', width: widthPercentage });
      });
    }
  }, {
    key: '_renderHeader',
    value: function _renderHeader(startOfWeek) {
      var _props2 = this.props,
          dates = _props2.dates,
          renderHeaderDate = _props2.renderHeaderDate;

      return dates.map(function (date, index) {
        var isStartOfWeek = index !== 0 && date.day() === startOfWeek;
        return _react2.default.createElement(_CalendarTableHeaderCell2.default, {
          key: date,
          date: date,
          showWeekDivider: isStartOfWeek,
          render: renderHeaderDate
        });
      });
    }
  }, {
    key: '_renderBody',
    value: function _renderBody(startOfWeek) {
      var _props3 = this.props,
          isLoading = _props3.isLoading,
          openings = _props3.openings;

      if (isLoading) {
        return this._renderLoadingBody();
      } else if (openings && openings.length) {
        return this._renderRows(startOfWeek);
      }
      return this._renderEmptyBody();
    }
  }, {
    key: '_renderRows',
    value: function _renderRows(startOfWeek) {
      var _props4 = this.props,
          openings = _props4.openings,
          dates = _props4.dates,
          timeInterval = _props4.timeInterval,
          openingTarget = _props4.openingTarget,
          onOpeningClick = _props4.onOpeningClick,
          renderRowTime = _props4.renderRowTime,
          renderOpening = _props4.renderOpening;

      var firstTime = openings[0].time;
      var rows = [];
      if (!(0, _dateUtils.isCurrentTimeZone)(firstTime)) {
        rows.push(this._renderTimeZoneWarning(firstTime));
      }
      var collection = new _OpeningCollection2.default(openings, {
        timeZone: firstTime.utcOffset(),
        interval: timeInterval
      });
      collection.forEachTime(function (time, openingsByTime, index) {
        rows.push(_react2.default.createElement(_CalendarTableRow2.default, {
          key: time,
          time: time,
          dates: dates,
          index: index,
          startOfWeek: startOfWeek,
          openings: openingsByTime,
          openingTarget: openingTarget,
          onOpeningClick: onOpeningClick,
          renderRowTime: renderRowTime,
          renderOpening: renderOpening
        }));
      });
      return rows;
    }
  }, {
    key: '_renderTimeZoneWarning',
    value: function _renderTimeZoneWarning(time) {
      var dates = this.props.dates;

      return _react2.default.createElement(
        'tr',
        { key: 'timeZoneWarning' },
        _react2.default.createElement(
          'td',
          { className: 'calendar-table__message', colSpan: dates.length + 2 },
          _react2.default.createElement(
            'div',
            { className: 'warning-message small-message inline-block' },
            'These open appointments are in a different time zone:',
            _react2.default.createElement(
              'strong',
              { key: 'timeZoneAbbr', className: 'calendar-table__time-zone-abbr' },
              ' ',
              time.zoneAbbr()
            )
          )
        )
      );
    }
  }, {
    key: '_renderEmptyBody',
    value: function _renderEmptyBody() {
      var _props5 = this.props,
          dates = _props5.dates,
          nextAvailableDate = _props5.nextAvailableDate,
          phoneNumber = _props5.phoneNumber,
          onNextAvailableClick = _props5.onNextAvailableClick;

      var warningMessage = void 0;
      var nextAvailableDateLink = void 0;
      if (nextAvailableDate && onNextAvailableClick) {
        warningMessage = 'There are no appointments available online this week.';
        nextAvailableDateLink = _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'a',
            { key: 'nextAvailableDateLink', href: 'javascript:void(0);', onClick: onNextAvailableClick },
            'Go to the next available appointment on ',
            nextAvailableDate.format('l')
          )
        );
      } else if (phoneNumber) {
        warningMessage = 'There are no appointments available online. Please call the office at ' + phoneNumber + '.';
      } else {
        warningMessage = 'There are no appointments available online.';
      }
      return _react2.default.createElement(
        'tr',
        { key: 'emptyWarning' },
        _react2.default.createElement(
          'td',
          { className: 'calendar-table__message', colSpan: dates.length + 2 },
          _react2.default.createElement(
            'div',
            { className: 'warning-message inline-block' },
            warningMessage,
            nextAvailableDateLink
          )
        )
      );
    }
  }, {
    key: '_renderLoadingBody',
    value: function _renderLoadingBody() {
      var dates = this.props.dates;

      return _react2.default.createElement(
        'tr',
        { key: 'loadingMessage' },
        _react2.default.createElement(
          'td',
          { className: 'calendar-table__message', colSpan: dates.length + 2 },
          _react2.default.createElement(
            'div',
            { className: 'openings-calendar__loading-message' },
            _react2.default.createElement('i', { className: 'icon-spinner spin' }),
            ' Searching for open appointments\u2026'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var dates = this.props.dates;
      var startOfWeek = this.props.startOfWeek;

      if (startOfWeek == null) {
        startOfWeek = this._getStartOfWeek(dates);
      }
      return _react2.default.createElement(
        'table',
        {
          className: 'table data-table calendar-table highlight-rows highlight-cols',
          'data-toggle-columns': true
        },
        _react2.default.createElement('colgroup', { className: 'calendar-table__time-colgroup' }),
        this._renderColgroups(),
        _react2.default.createElement('colgroup', { className: 'calendar-table__time-colgroup' }),
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('th', null),
            this._renderHeader(startOfWeek),
            _react2.default.createElement('th', null)
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this._renderBody(startOfWeek)
        )
      );
    }
  }]);

  return CalendarTable;
}(_react2.default.Component);

CalendarTable.displayName = 'CalendarTable';
CalendarTable.propTypes = {
  isLoading: _propTypes2.default.bool,
  openings: _propTypes2.default.arrayOf(_reactUtils.openingShape),
  nextAvailableDate: _reactUtils.momentShape,
  dates: _propTypes2.default.arrayOf(_reactUtils.momentShape).isRequired,
  timeInterval: _propTypes2.default.number,
  startOfWeek: _propTypes2.default.number,
  phoneNumber: _propTypes2.default.string,
  openingTarget: _propTypes2.default.string,
  navWidth: _propTypes2.default.number,
  onNextAvailableClick: _propTypes2.default.func,
  onOpeningClick: _propTypes2.default.func,
  renderHeaderDate: _propTypes2.default.func,
  renderRowTime: _propTypes2.default.func,
  renderOpening: _propTypes2.default.func
};
CalendarTable.defaultProps = {
  isLoading: false,
  openings: [],
  timeInterval: 30,
  navWidth: 4
};
exports.default = CalendarTable;